/* eslint-disable react/jsx-no-useless-fragment */
import { Constants } from "appConstants";
import useBackofficeUserToken from "hooks/useBackofficeUserToken";
import { BackofficeLayout } from "layouts";
import { Page404 } from "pages";
import { Login, TermDetails, UserNotFound } from "pages/backoffice";
import Term from "pages/backoffice/Tenant/Details/TermForm";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useTenant } from "store/contextTenant";
import { Tab, Tabs } from "utils/types";

interface BackofficeRoutesProps {
	tabs: { [name: string]: Tab };
}

export default function BackofficeRoutes(
	props: Readonly<BackofficeRoutesProps>
) {
	const { tabs } = props;
	const user = useBackofficeUserToken();
	const contextTenant = useTenant();

	function isAbleToDefineRoutes(isNecessaryTenant: boolean) {
		return !isNecessaryTenant || (isNecessaryTenant && contextTenant.tenant);
	}

	return (
		<Routes>
			{user && (
				<Route key="backoffice" path="/" element={<BackofficeLayout />}>
					{Object.entries(tabs).map(
						([tabKey, tabValue]) =>
							isAbleToDefineRoutes(tabValue.isNecessaryTenant) && (
								<React.Fragment key={`${tabKey}-routes`}>
									{tabValue?.BaseListComponent && (
										<Route
											key={tabKey}
											path={`/${tabKey}`}
											element={<tabValue.BaseListComponent />}
										/>
									)}
									{tabValue?.BaseCreateComponent && (
										<Route
											key={`${tabKey}-create`}
											path={`/${tabKey}/create`}
											element={<tabValue.BaseCreateComponent />}
										/>
									)}
									{tabValue?.BaseDetailsComponent && (
										<Route
											key={`${tabKey}-details`}
											path={`/${tabKey}/:id`}
											element={<tabValue.BaseDetailsComponent />}
										/>
									)}
									{tabValue?.BaseEditComponent && (
										<Route
											key={`${tabKey}-edit`}
											path={`/${tabKey}/:id/edit`}
											element={<tabValue.BaseEditComponent />}
										/>
									)}
								</React.Fragment>
							)
					)}
					<Route
						key="base-terms"
						path="/tenants/:id/terms/:activeTermId"
						element={<TermDetails />}
					/>
					<Route
						key="add-new-term"
						path="tenants/term/new"
						element={<Term />}
					/>
					<Route
						key="edit-term"
						path="tenants/term/:termId"
						element={<Term />}
					/>
					<Route
						key="add-new-term-to-existing-term-type"
						path="tenants/term/new/:activeTermId"
						element={<Term />}
					/>
					<Route key="404page" path="/*" element={<Page404 />} />
					<Route
						key="base-tenant"
						path="/"
						element={<Navigate to={Constants.tabs[Tabs.TENANTS].baseUrl} />}
					/>
				</Route>
			)}
			<Route key="login" path="/*" element={<Login />} />
			<Route path="/sem-cadastro" element={<UserNotFound />} />
		</Routes>
	);
}
